import React, { useState } from "react";
import { Link } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Header from "../../../component/common/Header";
import { TextField } from "@fluentui/react/lib/TextField";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { confirmDispatched } from "../../../actions/DakManagement";
import { toast } from "react-toastify";
import { getCookie } from "../../../utils";
import { Typeahead } from "react-bootstrap-typeahead";
import { mailTypes } from "../misc/mailTypes";

function DakManagement(props) {
  const { details } = props;
  const initialValues = {
    awb: "",
    mailType: "",
    otherMailType: "",
  };

  const [values, setValues] = useState(initialValues);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  function onUserInput(field, value) {
    setShowErrorAlert(false);
    values[field] = value;
    setValues({ ...values });
  }

  async function onSubmit() {
    setShowLoader(true);
    if (values.mailType !== "Other") delete values.otherMailType;
    try {
      if (Object.values(values).some((item) => !item.length)) {
        setShowErrorAlert(true);
        setShowLoader(false);
        return;
      }
      const payload = values;
      if (values.mailType === "Other") payload.mailType = values.otherMailType;
      await confirmDispatched(payload, details.id);
      toast("Dak Updated");
      props.history.goBack();
    } catch (e) {
      console.log(e, "eee");
    }
    setShowLoader(false);
  }

  return (
    <div className="container-fluid">
      <div className="row">
        {/* <div className="col-md-2 px-0">
          <Header />
        </div> */}
        {showLoader ? (
          <div className="col-md-12 mt-3">
            <p>Please wait ...</p>
          </div>
        ) : (
          <div className="col-md-12 mt-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <h1 className="page-title">DAK Update</h1>
              <Link
                to={CONSTANT.component.dakManagementList.url}
                className="btn btn-sm submit-button p-2"
              >
                <i className="fa fa-list mr-2" />
                Dak list
              </Link>
            </div>
            <div className="col-md-12" style={{ border: "1p solid red" }}>
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="mt-3">
                  <p>
                    From:{" "}
                    <span style={{ fontWeight: "bold" }}>{details.name}</span>
                  </p>
                </div>
                <div className="mt-3">
                  <p>
                    To: <span style={{ fontWeight: "bold" }}>{details.to}</span>
                  </p>
                </div>
                <div className="mt-3">
                  <p>Description:</p>
                  <p style={{ fontWeight: "bold" }}>{details.description}</p>
                </div>
                <div
                  className="mt-3"
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                  }}
                >
                  <Typeahead
                    className="mr-2"
                    label="Mail Type"
                    id="receipent"
                    placeholder="Select Mail type"
                    labelKey={(option) => `${option.name}`}
                    required
                    onChange={(e) => onUserInput("mailType", e[0] && e[0].name)}
                    value={values.mailType}
                    options={mailTypes}
                  />
                  {values.mailType === "Other" ? (
                    <TextField
                      label="Mail Type"
                      className="flex-1 mr-2"
                      required
                      onChange={(e) =>
                        onUserInput("otherMailType", e.target.value)
                      }
                      value={values.otherMailType}
                    />
                  ) : null}
                  <TextField
                    label="AWB Number"
                    className="flex-1"
                    required
                    onChange={(e) => onUserInput("awb", e.target.value)}
                    value={values.awb}
                    disabled={!values.mailType}
                  />
                </div>
                <div className="col-md-12 mt-3">
                  {showErrorAlert && (
                    <MessageBar
                      delayedRender={false}
                      messageBarType={MessageBarType.error}
                    >
                      Please fill all fields
                    </MessageBar>
                  )}
                </div>
                <div
                  className="mt-3"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <PrimaryButton text="Confirm Dispatched" onClick={onSubmit} />
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DakManagement;
